import axios from 'axios'

// Edit-lock API. Only one editor at a time holds a dashboard's lock; the
// server expires it after LOCK_TTL (90s) of missed heartbeats, so a browser
// that dies without releasing never wedges the dashboard permanently.
// See docs/dashboard-shared-editing-plan.md section 6.

const authConfig = (access) => ({
  headers: {
    'Content-type': 'application/json',
    Authorization: `Bearer ${access}`,
  },
})

const lockUrl = (code) => `/api/v1/dashboard/${code}/lock/`

export async function acquireDashboardLock(code, sessionId, access) {
  const { data } = await axios.post(lockUrl(code), { session_id: sessionId }, authConfig(access))
  return data
}

export async function heartbeatDashboardLock(code, sessionId, access) {
  const { data } = await axios.post(
    `${lockUrl(code)}heartbeat/`,
    { session_id: sessionId },
    authConfig(access),
  )
  return data
}

export async function releaseDashboardLock(code, sessionId, access) {
  const { data } = await axios.delete(lockUrl(code), {
    ...authConfig(access),
    data: { session_id: sessionId },
  })
  return data
}

// Release on `pagehide`, where the browser will not wait for a normal XHR.
//
// Deliberately fetch(keepalive) rather than navigator.sendBeacon: sendBeacon
// cannot set an Authorization header, and the only ways around that are
// putting the JWT in the request body or opening an unauthenticated release
// endpoint — both of which trade a real auth boundary for a convenience.
// fetch's keepalive flag survives unload the same way and keeps the normal
// bearer-token contract.
//
// This is best-effort by design. If it does not land, the server's 90s
// heartbeat TTL frees the lock anyway; that fallback is why an abandoned tab
// can never wedge a dashboard permanently.
export function releaseDashboardLockOnUnload(code, sessionId, access) {
  if (typeof fetch !== 'function') return false
  try {
    fetch(lockUrl(code), {
      method: 'DELETE',
      keepalive: true,
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${access}`,
      },
      body: JSON.stringify({ session_id: sessionId }),
    })
    return true
  } catch (error) {
    return false
  }
}
